module.exports = __webpack_public_path__ + "img/dingzhiyansemochoubiandai.min.0cd4060a.png";